import { Loading, Notification } from 'element-ui'
import $ from 'jquery'

export const log = (d) => {
    window.console.log(JSON.parse(JSON.stringify(d)))
}

export const obj = (o, start, end) => {
    o = $.extend(true, {}, o)
    
    if(start === null || start === false)
        return Object.entries(o)
    else
        return Object.entries(o).slice(start, end)
}

export const arr = (o, start, end) => {
    return obj(o, start, end).map(e => e[1])
}

export let _fullScreenLoader = false
export const blockScreen = (message) => {
    if(_fullScreenLoader !== false)
        _fullScreenLoader.text = message
    else {
        _fullScreenLoader = Loading.service({
            lock: true,
            text: message || '',
            fullscreen: true,
            customClass: 'peer-processing'
        })
    }
}

export const blockScreenTransparent = (target, message) => {
    _fullScreenLoader = Loading.service({
        target: target || 'document.body',
        lock: true,
        text: message || '',
        fullscreen: true,
        customClass: message ?'processing-no-loader' :'transparent-processing'
    })
}

export const releaseScreen = () => {
    if(_fullScreenLoader !== false) {
        _fullScreenLoader.close()
        _fullScreenLoader = false
    }
}

export const deleteKey = (obj, path) => {
    const _obj = $.extend(true, {}, obj)
    const keys = path.split('.')
    
    keys.reduce((acc, key, index) => {
        if(index === keys.length - 1) {
            delete acc[key]
            return true
        }
        return acc[key]
    }, _obj)
    
    return _obj
}

export const notify = (type, message, title, isHtml = false, duration = 15000) => {
    let types = {
        S: 'success',
        I: 'info',
        W: 'warning',
        E: 'error'
    }
    
    Notification({
        title: title || '',
        message: message,
        type: types[type] || types.E,
        position: 'top-right',
        duration: duration,
        showClose: true,
        dangerouslyUseHTMLString: isHtml
    })
}

export const convertToSelectOptions = (d) => {
    let out = []
    $.each(d, (k, v) => {
        out.push({
            label: v,
            value: $.trim(k)
        })
    })
    
    return out
}

export const download = (url) => {
    let hiddenIFrameID = 'hiddenDownloader'
    let iframe = document.getElementById(hiddenIFrameID)
    
    if(iframe === null) {
        iframe = document.createElement('iframe')
        iframe.id = hiddenIFrameID
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
    }
    
    iframe.src = url
}

export const ucfirst = (s, lower = true) => {
    return (lower ?s.toLowerCase() :s).replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase()
    })
}

export const boolToStr = (val) => {
    if(val === true)
        return 'true'
    
    if(val === false)
        return 'false'
    
    return val
}

export const strToBool = (val) => {
    if(val === 'true')
        return true
    
    if(val === 'false')
        return false
    
    return val
}

export default {
    log, arr, obj,
    blockScreen, blockScreenTransparent, releaseScreen,
    notify, convertToSelectOptions,
    download, ucfirst,
    boolToStr, strToBool, deleteKey
}
